/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';

import type * as Types from '@sg/graphql-schema';
export type CartLedgerFragment = {
  readonly __typename?: 'Ledger';
  readonly tax: number;
  readonly subtotal: number;
  readonly feesTotal: number;
  readonly discountsTotal: number;
  readonly creditsTotal: number;
  readonly tip: number;
  readonly discounts: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly fees: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
};

export type OrderStatusCartLineItemFragment = {
  readonly __typename: 'LineItem';
  readonly id: string;
  readonly slug: string;
  readonly quantity: number;
  readonly cost: number;
  readonly customName: string | null;
  readonly perItemCost: number;
  readonly favorited: boolean;
  readonly isCustom: boolean;
  readonly dressingMode: Types.DressingMode;
  readonly addedIngredients: ReadonlyArray<{
    readonly __typename: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly removedIngredients: ReadonlyArray<{
    readonly __typename: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly product: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly isCustom: boolean;
    readonly enableDressingDetails: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
  };
  readonly mixedDressingDetails: ReadonlyArray<{
    readonly __typename?: 'MixedDressingDetails';
    readonly ingredientId: string;
    readonly weight: Types.DressingWeight;
  }>;
};

export type DeliveryOrderDetailFragment = {
  readonly __typename: 'DeliveryOrderDetail';
  readonly id: string;
  readonly tip: number;
  readonly deliveryFee: number;
  readonly vendor: string;
  readonly orderId: string;
  readonly vendorRestaurantId: string;
  readonly estimatedDeliveryTime: string | null;
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export const CartLedgerFragmentDoc = gql`
  fragment CartLedger on Ledger {
    tax
    subtotal
    feesTotal
    discountsTotal
    creditsTotal
    tip
    discounts {
      id
      __typename
      name
      amount
      description
    }
    credits {
      id
      __typename
      name
      amount
      description
    }
    fees {
      id
      __typename
      name
      amount
      description
    }
  }
`;
export const OrderStatusCartLineItemFragmentDoc = gql`
  fragment OrderStatusCartLineItem on LineItem {
    id
    __typename
    slug
    quantity
    cost
    customName
    perItemCost
    favorited
    isCustom
    addedIngredients {
      id
      __typename
      name
      kind
      asset {
        url
      }
    }
    removedIngredients {
      id
      __typename
      name
      kind
      asset {
        url
      }
    }
    product {
      id
      __typename
      name
      slug
      isCustom
      enableDressingDetails
      asset {
        url
      }
      ingredients {
        id
        __typename
        name
        kind
      }
    }
    mixedDressingDetails {
      ingredientId
      weight
    }
    dressingMode
  }
`;
export const DeliveryOrderDetailFragmentDoc = gql`
  fragment DeliveryOrderDetail on DeliveryOrderDetail {
    id
    __typename
    tip
    deliveryFee
    vendor
    orderId
    vendorRestaurantId
    estimatedDeliveryTime
    address {
      id
      __typename
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;
